import styled from "styled-components";
import { theme } from "../../../../constants/StyledComponents";

export const StyledProfessionalHistory = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  scrollbar-gutter: stable !important;
`;

export const ProfessionalHistoryHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  width: 100%;
  padding: 20px;
  gap: 20px;
  flex-wrap: wrap;

  & .title-switch {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 20px;
    flex-wrap: wrap;
  }
`;

export const StyledProfessionalHistoryContent = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px;

  & .empty-state {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    & > div {
      margin: ${theme.variables.height_4};
    }
  }

  & .content {
    & .filters {
      display: flex;
      flex-direction: row;
      gap: 20px;
      align-items: center;
    }

    & .two-columns {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    & .panel-filters {
      display: flex;
      flex-direction: column;
      gap: 20px;
    }

    & .active-filters {
      margin-top: 20px;
    }
  }
`;

export const StyledExpandTable = styled.div`
  margin-top: 20px;
`;
